import {css, useTheme} from '@mui/material';
import {
  GetStylesFunction,
  LoadingSpinner,
  StateId,
  mixins,
  ConfigObjectType,
  PaginatedResponse,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {useCallback, useState} from 'react';

import FetchedDataGridContainer from 'src/js/containers/grid/components/FetchedDataGridContainer';
import {GridReducerInjector} from 'src/js/containers/grid/components/GridReducerInjector';
import {SelectedRow} from 'src/js/containers/grid/grid_types';
import {LIST_WRAPPER_BOX_MIN_HEIGHT_PX} from 'src/js/containers/list/list_constants';

interface OwnProps {
  filterAndSearchStateId: StateId;
  gridId: string;
  serviceUrls?: any;
  onGridInitialize: () => void;
  handlePaginationDataChange?: (count?: number) => void;
  onDataLoaded?: (data: PaginatedResponse | undefined) => void;
  config: ConfigObjectType;
  showPageSize?: boolean;
  selectedRow?: SelectedRow;
  dataTransformFunction?: (data: any) => any;
  featureName?: string;
}

type Props = OwnProps;

export const MUIListWrapperBox: React.FC<Props> = (props) => {
  const {
    filterAndSearchStateId,
    gridId,
    serviceUrls,
    onDataLoaded,
    onGridInitialize,
    config,
    handlePaginationDataChange,
    showPageSize,
    selectedRow,
    dataTransformFunction,
    featureName,
  } = props;
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const onLoadingChange = useCallback((newIsLoading: boolean) => {
    setIsLoading(newIsLoading);
  }, []);

  const styles = getStyles({theme, params: {isLoading}});

  return (
    <div css={styles.dlListWrapperBox}>
      <div
        className={classNames(
          'dlLoadingSpinnerContainer',
          'dlFlexBoxContainerInContainer',
          {
            dlLoadingSpinnerParent: isLoading,
          }
        )}
      >
        <LoadingSpinner isVisible={isLoading} />
        {/* Move into new Component */}
        <div css={styles.dlListContent}>
          <GridReducerInjector gridId={gridId}>
            <FetchedDataGridContainer
              config={config}
              filterAndSearchStateId={filterAndSearchStateId}
              configPath={serviceUrls.gridConfigConfigPath}
              gridId={gridId}
              apiUrl={serviceUrls.searchService}
              onLoadingChange={onLoadingChange}
              onDataLoaded={onDataLoaded}
              onGridInitialize={onGridInitialize}
              domLayout={'autoHeight'}
              handlePaginationDataChange={handlePaginationDataChange}
              showPageSize={showPageSize}
              selectedRow={selectedRow}
              dataTransformFunction={dataTransformFunction}
              featureName={featureName}
            />
          </GridReducerInjector>
        </div>
      </div>
    </div>
  );
};

MUIListWrapperBox.displayName = 'MUIListWrapperBox';

const getStyles: GetStylesFunction = (options) => ({
  dlListWrapperBox: css`
    ${mixins.dlFlexBoxContainerInContainer};
    order: 1;
    overflow: hidden;
    background-color: var(--dlBackgroundPanelColor);
    width: 100%;
    min-height: ${options?.params?.isLoading
      ? `${LIST_WRAPPER_BOX_MIN_HEIGHT_PX}px`
      : 'unset'};
  `,
  dlListContent: css`
    ${mixins.dlFlexBoxContainerInContainer};
    color: ${options?.theme?.palette.custom.coolGray['800']};
    flex-direction: column;
  `,
});
